import { Users } from 'lucide-react';
import { useGetOne, useGetResourceLabel, useTranslate } from 'ra-core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../../components/admin/data-table';
import { Error as ErrorPage } from '../../../components/admin/error';
import { Loading } from '../../../components/admin/loading';
import { AssignmentEmpty } from '../../Moonstar/AssignmentEmpty';
import { MoonstarList } from '../../Moonstar/MoonstarList';
import { MoonstarListActions } from '../../Moonstar/MoonstarListActions';
import { type KpiResponseDto } from '../types';
import { BulkAddKpiAssignees } from './BulkAddKpiAssignee';

export const KpiAssigneeList = () => {
  const { kpiId } = useParams<{ kpiId: string }>();
  const numericKpiId = Number(kpiId);
  const filterKey = 'excludeKpiIds';
  const kpi = useGetOne<KpiResponseDto>('kpis', { id: numericKpiId });
  const translate = useTranslate();
  const getResourceLabel = useGetResourceLabel();

  if (kpi.isPending) {
    return <Loading />;
  } else if (kpi.isError) {
    return (
      <ErrorPage
        resetErrorBoundary={() => void kpi.refetch()}
        error={kpi.error}
      />
    );
  }

  return (
    <MoonstarList
      empty={
        <AssignmentEmpty
          message="moonstar.kpiAssignees.noUnassigned"
          to={`/kpis/${kpi.data.id}/data`}
          icon={<Users />}
          label="moonstar.kpiAssignees.viewAssignees"
        />
      }
      filter={{
        [filterKey]: [numericKpiId],
      }}
      sort={{ field: 'name', order: 'ASC' }}
      actions={<MoonstarListActions hideCreate />}
      resource="units"
      title={[
        { label: getResourceLabel('kpis', 2), href: '/kpis' },
        kpi.data.name,
        translate('moonstar.kpiAssignees.addAssignees'),
      ]}
    >
      <DataTable
        bulkActionButtons={<BulkAddKpiAssignees kpi={kpi.data} />}
        rowClick={false}
      >
        <DataTable.Col source="name" />
      </DataTable>
    </MoonstarList>
  );
};
